<template>
  <div class="adviser-faq-categories">
    <section
      v-for="(category, index) in categories"
      :key="category.title"
      class="faq-category"
    >
      <!-- Categories are numbered 1-7 as in the FAQ source document. -->
      <h2 class="category-title">{{ index + 1 }}. {{ category.title }}</h2>
      <!-- The mockup opens the first question of the first category. -->
      <Accordion
        :accordionData="category.faqs"
        :html="true"
        variant="adviser-faqs"
        :openIndex="index === 0 ? 0 : null"
      />
    </section>
  </div>
</template>

<script>
  import Accordion from '../../common/Accordion.vue';

  // Renders whitelabel.adviserFAQs: a heading plus an accordion stack per
  // category (spec 3.3, 4.7).
  export default {
    name: 'AdviserFaqCategories',
    components: {
      Accordion,
    },
    props: {
      // [{ title, faqs: [{ title, content }] }]
      categories: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../../../constants/styles/adviser-pages.scss';

  .adviser-faq-categories {
    display: flex;
    flex-direction: column;
    gap: 60px;
  }

  .category-title {
    @include adviser-font;
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    color: $adviser-text-black;
    margin: 0 0 40px 0;
  }
</style>
